import { ImageState } from "@/api/images-types";
import { pretty } from "@/utils/pretty";
import { blue, green, red } from "@mui/material/colors";
import { StateChip, StateChipProps } from "./StateChip";

type Props = {
  state: ImageState;
  size?: StateChipProps["size"];
};

const colors = {
  new: blue[500],
  retryScheduled: blue[500],
  waitingForImage: blue[500],
  waitingForChildDetection: blue[500],
  accepted: green[500],
  rejected: red[500],
  generationFailed: red[500],
};

export function ImageStateChip({ state, size }: Props) {
  return (
    <StateChip
      size={size}
      label={pretty(state, "capitalLetters")}
      color={colors[state]}
    />
  );
}
